import React, { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../../../context/GlobalContext';
import { Tabs } from '../../../interfaces/GlobalContext.interface';
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import { changeRef } from '../../../utils/locations';
import SearchResultsBox from '../../molecules/search-results-box/SearchResultsBox';
import './SearchBarHeader.scss';

// @ts-ignore
import iconSearch from '../../../assets/icons/CDA/icon_search.svg';
// @ts-ignore
import iconArrow from '../../../assets/icons/CDA/right_arrow.svg';
// @ts-ignore
import clearSearch from '../../../assets/icons/CDA/icon_clear-search.svg';
// @ts-ignore
import buildingIcon from '../../../assets/icons/CDA/icon_building.svg';
// @ts-ignore
import userIcon from '../../../assets/icons/CDA/icon_user.svg';
import useElasticSearch from '../../../hooks/useElasticSearch';
import { SearchResult } from '../../../interfaces/Article.interface';
import { sendDataLayer } from '../../../utils/functions';

const GATSBY_ELASTICSEARCH_URL = process.env.API_ELASTICSEARCH_URL;
const GATSBY_ELASTICSEARCH_API_KEY = process.env.API_ELASTICSEARCH_API_KEY;

const SearchBarHeader = () => {
    const { window } = useBrowserMode();
    const { selectedTab } = useContext(GlobalContext);

    const [showSelectorType, setShowSelectorType] = useState<boolean>(false);
    const [showSearchBar, setShowSearchBar] = useState<boolean>(false);
    const [activeSearchBar, setActiveSearchBar] = useState<boolean>(false);

    const [query, setQuery] = useState('');

    const {
        doSearch: doSearchElastic,
        result: resultElastic,
        isLoading,
        reset: resetElastic,
    } = useElasticSearch<SearchResult>({
        apikeyElastic: GATSBY_ELASTICSEARCH_API_KEY ?? '',
        urlElastic: GATSBY_ELASTICSEARCH_URL ?? '',
        boostIndex: ['cda_contentful_logstash'],
        selectedFields: [
            'id',
            'origin',
            'category',
            'title',
            'description',
            'tags',
            'iconType',
        ],
        onNoResults: () =>
            sendDataLayer({ event: 'cfm_no_result_elastic', keyword: query }),
        currentPage: 1,
    });

    const onQueryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        setQuery(e.target.value);
        doSearchElastic(e.target.value);
    };

    useEffect(() => {
        if (resultElastic && resultElastic.length > 0) {
            sendDataLayer({ event: 'cfm_hot_search_elastic', keyword: query });
        }
    }, [resultElastic]);

    useEffect(() => {
        const backdrop = document.querySelector('.a-backdrop-blur');

        if (activeSearchBar || showSearchBar) {
            backdrop?.classList.add('show');
            backdrop?.addEventListener('click', () => {
                backdrop?.classList.remove('show');
                handleCancel();
            });
            document?.addEventListener('keydown', (event) => {
                if (event.key === 'Escape' || event.keyCode === 27) {
                    backdrop?.classList.remove('show');
                    handleCancel();
                }
            });
        } else {
            backdrop?.classList.remove('show');
        }
    }, [activeSearchBar, showSearchBar]);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const redirect = changeRef(`resultados-busqueda/?query=${query}`);
        window?.location.assign(redirect);
    };

    const handleCancel = () => {
        setActiveSearchBar(false);
        setShowSearchBar(false);
        setQuery('');
        resetElastic();
    };

    const handleTabSelection = (type: Tabs) => {
        selectedTab.set(type);
        setShowSelectorType(false);
    };

    return (
        <div className="a-search-bar-container">
            <div className="selector-type">
                <div
                    className={`selector ${activeSearchBar ? 'hide_selector' : ''}`}
                    onClick={() => setShowSelectorType(!showSelectorType)}
                >
                    {selectedTab.get}
                    <img src={iconArrow} alt="selecion de tipo" />
                </div>
                {showSelectorType && (
                    <ul className="selector-list">
                        <li onClick={() => handleTabSelection('personas')}>
                            <img src={userIcon} alt="selecion de tipo" />
                            Personas
                        </li>
                        <li onClick={() => handleTabSelection('empresas')}>
                            <img src={buildingIcon} alt="selecion de tipo" />
                            Empresas
                        </li>
                    </ul>
                )}
            </div>

            <div
                className={`search-container ${
                    activeSearchBar ? 'search-container--active' : ''
                }`}
            >
                <div
                    className={`search-bar ${activeSearchBar ? 'active' : ''}`}
                >
                    <form
                        className="search-bar-form"
                        onSubmit={(e) => handleSubmit(e)}
                    >
                        <div className="input-group">
                            <input
                                type="text"
                                placeholder="Buscar"
                                value={query}
                                onChange={onQueryChange}
                                onClick={() => setActiveSearchBar(true)}
                                name="query"
                                autoComplete="off"
                                className="gtmBusacadorHome mobile"
                            />
                            <input
                                type="text"
                                placeholder="Busca por palabra clave"
                                value={query}
                                onChange={onQueryChange}
                                onClick={() => setActiveSearchBar(true)}
                                name="query"
                                autoComplete="off"
                                className="gtmBusacadorHome desktop"
                            />
                            {query.length > 0 && (
                                <button
                                    type="button"
                                    onClick={() => setQuery('')}
                                >
                                    <img
                                        src={clearSearch}
                                        alt="limpiar campo de búsqueda"
                                    />
                                </button>
                            )}
                        </div>
                        <button
                            type="submit"
                            className="input-btn"
                            disabled={query.length <= 2}
                        >
                            <img src={iconSearch} alt="botón de buscar" />
                        </button>
                    </form>
                    {activeSearchBar && <p onClick={handleCancel}>Cancelar</p>}
                </div>

                {(resultElastic || isLoading) && (
                    <SearchResultsBox
                        results={resultElastic || []}
                        showLoader={isLoading}
                        query={query}
                    />
                )}
            </div>

            {showSelectorType && (
                <div
                    className="settings-bg"
                    onClick={() => setShowSelectorType(false)}
                />
            )}
        </div>
    );
};

export default SearchBarHeader;
